import React from "react";

function ActiveIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#active-icon-clip)">
        <path
          d="M4.87283 9.33744L7.24573 12.0572L13.1205 5.95264"
          stroke="#3CAF47"
          strokeWidth="1.19028"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.99571 17.3396C13.5996 17.3396 17.3318 13.6074 17.3318 9.00355C17.3318 4.39967 13.5996 0.66748 8.99571 0.66748C4.39182 0.66748 0.659637 4.39967 0.659637 9.00355C0.659637 13.6074 4.39182 17.3396 8.99571 17.3396Z"
          stroke="#3CAF47"
          strokeWidth="1.19028"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="active-icon-clip">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ActiveIcon;
